module.exports = __webpack_public_path__ + "img/nail3.6b066573.jpg";